/**
 * 物料文档：
 * 1、【金山文档 | WPS云文档】 Saas筛选日语翻译（截止2412）https://365.kdocs.cn/l/ccDZJkTMPfW2
 * 2、【金山文档 | WPS云文档】 【日文翻译】2025新增的翻译 https://365.kdocs.cn/l/cnnHuwYtKoM9
 * 群:冯万敏邀请你加入「【国内版本】SaaS多语言处理-前端&服务端」，快点击链接加入吧 https://woa.wps.cn/invite/a2swn8j4dse?channel=stable
 * */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import { getLang, LANG_TAG_ZH_CN, LANG_TAG_ZH_HK, LANG_TAG_EN_US, LANG_TAG_JA_JP, LANG_TAG_ES_MX } from '@kdocs/i18n'
import zhCN from './zh-CN'
import enUS from './en-US'
import jaJP from './ja-JP'
import zhHK from './zh-HK'
import esMX from './es-MX'

const defaultLang = getLang({
  langsSupported: [
    LANG_TAG_ZH_CN,
    LANG_TAG_ZH_HK,
    LANG_TAG_EN_US,
    LANG_TAG_JA_JP,
    LANG_TAG_ES_MX,
  ],
})

const i18n: any = new VueI18n({
  locale: defaultLang || 'zh-CN',
  fallbackLocale: defaultLang || 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'ja-JP': jaJP,
    'zh-HK': zhHK,
    'es-MX': esMX,
  },
  silentTranslationWarn: true,
})

export default i18n
